import React, { useEffect, useMemo, useState } from 'react';
import { Button } from '@mui/material';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
// import CheckBox from '@inovua/reactdatagrid-community/packages/CheckBox'

const ReactDataTableBuilder = ({tableData={}, idProperty, minHeight=550, downloadFileName='grid-data.csv', exportCSV}) => {
  const gridStyle = useMemo(() => ({minHeight}), [minHeight]);
  const [gridRef, setGridRef] = useState(null);
  const [data, setData] = useState({...(tableData || {})});

  useEffect(() => {
    setData({...tableData})
  }, [tableData]);
  

  const downloadBlob = (blob, fileName = 'grid-data.csv') => {
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
  
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.position = 'absolute';
    link.style.visibility = 'hidden';
  
    document.body.appendChild(link);
  
    link.click();
  
    document.body.removeChild(link);
  };

  function export2CSV () {
    const SEPARATOR = ',';
    const columns = gridRef.current.visibleColumns;

    const header = columns.map((c) => c.name).join(SEPARATOR);
    const rows = gridRef.current.data.map((data) => columns.map((c) => data[c.id]).join(SEPARATOR));

    const contents = [header].concat(rows).join('\n');
    const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });

    downloadBlob(blob, `${downloadFileName}.csv`);
  }

  return data?.columns?.length > 0 ?(
    <>
      { exportCSV ? (<Button variant="contained" onClick={export2CSV} sx={{mb: 1}}>Export</Button>) : null}
      <ReactDataGrid
        handle={setGridRef}
        // idProperty={idProperty || "rdg_row_id"}
        idProperty="rdg_row_id"
        showColumnMenuTool={false}
        columns={data?.columns || []}
        dataSource={data?.dataSource || []}
        style={gridStyle}
      />
    </>
  ) : null;
}
 
export default React.memo(ReactDataTableBuilder);
